import Link from "next/link";

export default function Footer2() {
  return (
    <>
      <footer>
        <div className="footer-area secondary-footer black-bg-2 pt-65">
          <div className="container">
            <div className="main-footer pb-15 mb-30">
              <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="footer-widget footer-col-1 mb-40">
                    <div className="footer-logo mb-30">
                      <Link href="/">
                        <img src="/assets/img/logo/logo-white.png" alt="logo" />
                      </Link>
                    </div>
                    <div className="footer-content">
                      <p>
                        Purchase stylish yet reliable furniture for your home
                        and office space from Bohesto. We are your premium
                        furniture company.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="footer-widget footer-col-2 ml-30 mb-40">
                    <h4 className="footer-widget__title mb-30">Quick Links</h4>
                    <div className="footer-widget__links">
                      <ul>
                        <li>
                          <Link href="/">Home</Link>
                        </li>
                        <li>
                          <Link href="/about">About Us</Link>
                        </li>
                        <li>
                          <Link href="/shop">Shop</Link>
                        </li>
                        <li>
                          <Link href="/blog">Blogs</Link>
                        </li>
                        <li>
                          <Link href="/contact">Contacts</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="footer-widget footer-col-3 mb-40">
                    <h4 className="footer-widget__title mb-30">Other Links</h4>
                    <div className="footer-widget__links">
                      <ul>
                        <li>
                          <Link href="/Cookies-Policy">Cookies Policy</Link>
                        </li>
                        <li>
                          <Link href="/Privacy-Policy">Privacy Policy</Link>
                        </li>
                        <li>
                          <Link href="/Cancellation-Policy">
                            Cancellation Policy
                          </Link>
                        </li>
                        <li>
                          <Link href="/Terms-and-Condition">
                            Terms & Condition
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="footer-widget footer-col-4 mb-40">
                    <h4 className="footer-widget__title mb-30">
                      Social Network
                    </h4>
                    <div className="footer-widget__links">
                      <ul>
                        <li>
                          <Link
                            href="https://www.pinterest.com/Bohesto/"
                            target="_blank"
                          >
                            <i className="fab fa-pinterest" />
                            Pinterest
                          </Link>
                        </li>
                        {/* <li>
                          <Link
                            href="https://www.linkedin.com/in/bohesto/"
                            target="_blank"
                          >
                            <i className="fab fa-linkedin" />
                            Linkedin
                          </Link>
                        </li> */}
                        <li>
                          <Link
                            href="https://www.youtube.com/@bohesto"
                            target="_blank"
                          >
                            <i className="fab fa-youtube" />
                            Youtube
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="footer-cta pb-20">
                  <div className="row justify-content-between">
                    <div style={{ display: "flex", gap: "10px" }}>
                      <div className="footer-cta__contact">
                        <div className="footer-cta__icon">
                          <i className="far fa-phone" />
                        </div>
                        <div className="footer-cta__text">
                          {/* <Link href="/tel:0123456">980. 029. 666. 99</Link> */}
                          <p style={{ margin: 0 }}>+852 44566765</p>
                        </div>
                      </div>

                      <div className="footer-cta__contact">
                        <div className="footer-cta__icon">
                          <i className="far fa-location" />
                        </div>
                        <div className="footer-cta__text">
                          <p style={{ margin: 0 }}>
                            Yu Yuet Lai Building, 43-55 Wyndham St, Central,
                            Hong Kong
                          </p>
                        </div>
                      </div>

                      <div className="footer-cta__contact">
                        <div className="footer-cta__icon">
                          <i className="far fa-envelope" />
                        </div>
                        <div className="footer-cta__text">
                          <p style={{ margin: 0 }}>info@bohesto.com</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-copyright black-bg-2">
            <div className="container">
              <div className="row align-items-center">
                <div>
                  <div className="footer-copyright__content">
                    <span>
                      Copyright 2024 ©{" "}
                      <Link href="/" className="ml-5">
                        {" "}
                        Bohesto
                      </Link>
                      . All rights reserved.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
